module.exports = __webpack_public_path__ + "img/stock3.6930b5b1.png";